import type { ReactNode } from "react";

/**
 * The box a full-width screen sits in: centred, capped, and inset from the edge.
 *
 * The pods screens each carried their own copy, identical but for the gap between sections, and
 * each repeated the phone breakpoint. `className` is for that gap and nothing else.
 */
export function PageContainer({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`mx-auto flex max-w-[1280px] flex-col p-8 max-md:p-4 ${className}`}>
      {children}
    </div>
  );
}
